/**
 * Testimonials Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Testimonials section.
 *
 * @namespace testimonials
 */

import Flickity from 'flickity';
import {register} from './../vendor/theme-scripts/theme-sections';
import debounce from '../util/debounce';

const sections = {};

const selectors = {
  testimonialWithImage: 'testimonials-with-image',
  testimonialSlider: '.testimonials__slider--',
  testimonialSlide: '.testimonial__slide',
  testimonialSliderArrow: '.testimonials__slider-arrow',
  prevArrow: '[data-prev-arrow]',
  nextArrow: '[data-next-arrow]',
  dataSlides: 'data-slides',
  dataSlideIndex: 'data-slide-index',
  classIsHidden: 'is-hidden',
  classIsSelected: 'is-selected',
  blockquote: 'blockquote',
};

class Testimonials {
  constructor(section) {
    this.container = section.container;
    const sectionId = section.id;
    this.slideshow = this.container.querySelector(selectors.testimonialSlider + sectionId);
    this.hasImage = this.container.classList.contains(selectors.testimonialWithImage);
    this.slides = this.container.querySelectorAll(selectors.testimonialSlide);
    this.sliderPrev = this.container.querySelector(selectors.prevArrow);
    this.sliderNext = this.container.querySelector(selectors.nextArrow);
    this.flkty = null;

    this.init();
  }

  init() {
    const self = this;

    const showArrows = () => {
      const slidesNumber = self.slides.length;
      const slidesNumberCustom = parseInt(self.slideshow.getAttribute(selectors.dataSlides));
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let flag = false;

      if (!self.hasImage) {
        const largeDesktopCheck = windowWidth > 1339 && slidesNumber > slidesNumberCustom;
        const desktopCheck = windowWidth <= 1339 && windowWidth > 1023 && slidesNumber > 3;
        const tabletCheck = windowWidth <= 1023 && windowWidth > 767 && slidesNumber > 2;
        const mobileCheck = windowWidth <= 767 && slidesNumber > 1;

        if (largeDesktopCheck || desktopCheck || tabletCheck || mobileCheck) {
          flag = true;
        }
      } else if (self.hasImage && slidesNumber > 1) {
        flag = true;
      }

      if (flag) {
        self.sliderPrev.classList.remove(selectors.classIsHidden);
        self.sliderNext.classList.remove(selectors.classIsHidden);
      } else {
        self.sliderPrev.classList.add(selectors.classIsHidden);
        self.sliderNext.classList.add(selectors.classIsHidden);
      }
    };

    this.flkty = new Flickity(this.slideshow, {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      adaptiveHeight: true,
      wrapAround: true,
      percentPosition: true,
      cellAlign: 'left',
      draggable: false,
      on: {
        ready: function () {
          showArrows();
        },
      },
    });

    window.addEventListener(
      'resize',
      debounce(function () {
        self.flkty.resize();
        showArrows();
      }, 100)
    );

    this.sliderPrev.addEventListener('click', function (e) {
      e.preventDefault();

      self.flkty.previous(true);
    });

    this.sliderNext.addEventListener('click', function (e) {
      e.preventDefault();

      self.flkty.next(true);
    });
  }

  onBlockSelect(evt) {
    // Ignore the cloned version
    const slide = this.slideshow.querySelector(`${selectors.testimonialSlide}--${evt.detail.blockId}`);
    const slideIndex = parseInt(slide.getAttribute(selectors.dataSlideIndex));

    // Go to selected slide, pause autoplay
    this.flkty.select(slideIndex);
    this.flkty.stopPlayer();
  }
}

const TestimonialsSection = {
  onLoad() {
    sections[this.id] = new Testimonials(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('testimonials', TestimonialsSection);
